export const SET_CREATE_ICP_FILTERS_KEY_VALUE = 'SET_CREATE_ICP_FILTERS_KEY_VALUE';
export const createICPFiltersKeyValueHash = (hash: any) => ({
  type: SET_CREATE_ICP_FILTERS_KEY_VALUE,
  payload: hash,
});

const initialState: any = {};

interface Action {
  type: string;
  payload: any;
}

const createICPFiltersKeyValueHashReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_CREATE_ICP_FILTERS_KEY_VALUE:
      return {
        ...action.payload,
      };

    default:
      return state;
  }
};
export default createICPFiltersKeyValueHashReducer;
